import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@miroculus/miroculus-ui';
const AccountSettings = lazy(() => import(
/* webpackChunkName: 'account-settings' */
'./AccountSettings'));
const loading = React.createElement(LoadingSpinner, { message: "Loading account settings..." });
const AccountSettingsLoader = () => (React.createElement(Suspense, { fallback: loading },
    React.createElement(AccountSettings, null)));
export default AccountSettingsLoader;
